import { UndoRedoState } from 'editor/src/store/editorModules/undoRedo/types';

const popNextStateReducer = (state: UndoRedoState) => {
  state.next.pop();
};

export default popNextStateReducer;
